import { Component, OnInit, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { GoogleTagService } from './core/tag/google-tag.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
//import {NGXLoggerMonitor, NGXLogInterface} from 'ngx-logger';

//import { NGXLogger } from 'ngx-logger';
import { BaseComponents } from './base.component';
import { LogService } from '../app/core/logger/logger_service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
    permission_recoding:Observable<boolean>;
    
    constructor(
        //protected injectorObj: Injector,
        private router: Router,
        private googleTageService: GoogleTagService,
        //private logger: NGXLogger
        private logger: LogService
    ) {
        //super(injectorObj);
        // routing to home page
        this.router.events.subscribe(routerEvent => {
            if (routerEvent instanceof NavigationStart) {
                // if (routerEvent.url === '/') {
                //     this.router.navigate(['home'], 
                //     {
                //         skipLocationChange: true
                //     }
                //     );
                // } else if (routerEvent.url === '/register') {
                //     this.router.navigate(['home'], {
                //         replaceUrl: true
                //     });
                // }
                if (routerEvent.url === '/register') {
                    this.router.navigate(['/'], {
                        replaceUrl: true
                    });
                }
            }
        });

    }

    ngOnInit() {
        this.permission_recoding = this.googleTageService.permission;
        //this.logger.registerMonitor(new MyLoggerMonitor());
        //if(environment.mode === 'pro'){
            // this.googleTageService.setTageGoogleAnalytic()
        
        // //}
        
    }

}
// export class MyLoggerMonitor implements NGXLoggerMonitor {
//     onLog(log: NGXLogInterface) {
//       console.log('NGX Logger: ', log);
//       console.log('NGX Config: ', environment.logger);
//     }
// }
